import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const ALL_CUSTOMERS_ID = 'all-customers';

export interface Customer {
  id: string;
  customer_legal_name: string;
  customer_business_name: string;
}

interface CustomerState {
  customers: Customer[] | null;
  selectedCustomer: Customer | null;
  setCustomers: (customers: Customer[]) => void;
  setSelectedCustomer: (selection: Customer | null) => void;
}

const useCustomerStore = create<CustomerState>()(
  persist(
    (set) => ({
      customers: null,
      selectedCustomer: null,

      setCustomers: (customers) => set({ customers }),
      setSelectedCustomer: (selection) => set({ selectedCustomer: selection }),
    }),
    {
      name: 'Customer-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export { useCustomerStore };
